webpackJsonp([263791100135453],{

/***/ 130:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(45);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _simple = __webpack_require__(12);
	
	var _reactstrap = __webpack_require__(25);
	
	var _styleModule = __webpack_require__(234);
	
	var _styleModule2 = _interopRequireDefault(_styleModule);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Copyright = function Copyright() {
	    return _react2.default.createElement(
	        "small",
	        { className: "text-secondary" },
	        "Copyright \xA9 ",
	        new Date().getFullYear(),
	        " Ethronsoft - All Rights Reserved"
	    );
	};
	
	var Disclaimers = function Disclaimers() {
	    return _react2.default.createElement(
	        _gatsbyLink2.default,
	        { to: "/policies" },
	        _react2.default.createElement(
	            "small",
	            null,
	            "Use Policies"
	        )
	    );
	};
	
	//HIDE SOCIALS until we have active social pages
	// const Socials = () => (
	//     <div>
	//         <a href="" className="px-2"><SvgIcon name="facebook" height="16px" /></a>
	//         <a href="" className="px-2"><SvgIcon name="twitter" width="16px" /></a>
	//         <a href="" className="px-2"><SvgIcon name="discord-2" width="16px" /></a>
	//     </div>
	// )
	
	exports.default = function () {
	    return _react2.default.createElement(
	        _reactstrap.Container,
	        { className: _styleModule2.default.body + " fillScreen d-flex flex-column justify-content-between" },
	        _react2.default.createElement("div", null),
	        _react2.default.createElement(
	            _simple.Centered,
	            null,
	            _react2.default.createElement(
	                "h2",
	                { className: "mb-4" },
	                "We Are Game"
	            ),
	            _react2.default.createElement(
	                "section",
	                null,
	                _react2.default.createElement(
	                    "p",
	                    null,
	                    "Indie to the core, our only objective is to engineer Art, ",
	                    _react2.default.createElement("br", null),
	                    " without compromise"
	                )
	            )
	        ),
	        _react2.default.createElement(
	            _reactstrap.Row,
	            { className: "pt-1 pb-1" },
	            _react2.default.createElement(
	                _reactstrap.Col,
	                { className: "d-flex justify-content-start" },
	                _react2.default.createElement(Copyright, null)
	            ),
	            _react2.default.createElement(
	                _reactstrap.Col,
	                { className: "d-flex justify-content-end" },
	                _react2.default.createElement(Disclaimers, null)
	            )
	        )
	    );
	};
	
	module.exports = exports["default"];

/***/ }),

/***/ 234:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"body":"src-components-complex-About----style-module---body---F0sgI"};

/***/ }),

/***/ 143:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _dec, _class;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _mobxReact = __webpack_require__(24);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _About = __webpack_require__(130);
	
	var _About2 = _interopRequireDefault(_About);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var AboutPage = (_dec = (0, _mobxReact.inject)(function (stores) {
	    return {
	        nav: stores.navigation_store
	    };
	}), _dec(_class = function (_React$Component) {
	    _inherits(AboutPage, _React$Component);
	
	    function AboutPage(props) {
	        _classCallCheck(this, AboutPage);
	
	        var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));
	
	        props.nav.setActiveScreen("about");
	        return _this;
	    }
	
	    AboutPage.prototype.render = function render() {
	        return _react2.default.createElement(_About2.default, null);
	    };
	
	    return AboutPage;
	}(_react2.default.Component)) || _class);
	
	
	AboutPage.wrappedComponent.propTypes = {
	    nav: _propTypes2.default.object.isRequired
	};
	
	exports.default = AboutPage;
	module.exports = exports["default"];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-about-js-4b6939548156c5cc77d0.js